export default __webpack_public_path__ + "static/media/sh3.a2ac4bdd.jpg";